import React from 'react';

import t from '../../../labels/labelling-utils';
import { makeClassNames } from '../../../utils/styles';
import { IconRefresh } from '../../atoms';
import './new-comments-badge.scss';

export interface INewCommentsBadgeProps {
  count: number;
  isShown?: boolean;
  onClick?: () => void;
}

const classNames = () =>
  makeClassNames({
    NewCommentsBadge: 'new-comments-badge',
    NewCommentsBadgeIcon: 'new-comments-badge__icon',
    NewCommentsBadgeText: 'new-comments-badge__text',
    IsVisible: 'is-visible',
  });

const NewCommentsBadge = ({ count, onClick, isShown }: INewCommentsBadgeProps) => {
  const cn = classNames();
  const newPostsText = `${count} ${
    count === 1 ? t('badge.new.comments.text.singular') : t('badge.new.comments.text.plural')
  }`;

  return (
    <a className={`${cn.NewCommentsBadge} ${isShown ? cn.IsVisible : ''}`} onClick={onClick}>
      <span className={cn.NewCommentsBadgeIcon}>
        <IconRefresh customSize={{ width: '24', height: '24' }} />
      </span>
      <span className={cn.NewCommentsBadgeText}>{newPostsText}</span>
    </a>
  );
};

export default NewCommentsBadge;
